export default __webpack_public_path__ + "images/industrial-icon@2x.png?97a1146a68551c2ad22e26db66ac30ff";